import React, { forwardRef, useImperativeHandle, useRef, useEffect } from 'react';

/**
 * Rectangular editorial plate holding a stack of persona images.
 * A thin antique-gold hairline frames the plate; a subtle veil pulses at
 * cross-fade peaks. The parent drives all animations through a single rAF
 * loop — no React re-renders during scroll.
 */
export const HeroPortraitMorph = forwardRef(({ personas }, ref) => {
  const imgRefs = useRef([]);
  const veilRef = useRef(null);
  const hairlineRef = useRef(null);

  useEffect(() => {
    imgRefs.current = imgRefs.current.slice(0, personas.length);
  }, [personas.length]);

  useImperativeHandle(ref, () => ({
    imgs: () => imgRefs.current,
    veil: () => veilRef.current,
    hairline: () => hairlineRef.current,
    length: personas.length,
  }), [personas.length]);

  return (
    <div className="portrait-morph" aria-hidden="true">
      {personas.map((p, i) => (
        <img
          key={p.src + i}
          ref={(el) => { imgRefs.current[i] = el; }}
          src={p.src}
          alt=""
          className="portrait-morph-img"
          style={{
            opacity: i === 0 ? 1 : 0,
            objectPosition: p.position || 'center center',
          }}
          draggable={false}
        />
      ))}
      <div ref={veilRef} className="portrait-morph-veil" />
      <div ref={hairlineRef} className="portrait-morph-hairline" />
    </div>
  );
});

HeroPortraitMorph.displayName = 'HeroPortraitMorph';
